export default __webpack_public_path__ + "static/media/16.892aca59.mp4";